import { EV } from 'enerx-shared'
export const appEnv = (info) => {
    if (info.isVirtual) {
        return EV.EnvTyp.Dev
    } else {
        return EV.EnvTyp.Stage
    } 
}